/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

export default (files) => {
  return new Promise(async (resolve, reject) => {
    var count = 1;
    for (var i = 0; i < files.length; i++) {
      let fileSize = files[i].size;
      let itemType = files[i].type;

      if (fileSize > 5242880) {
        resolve(
          'File "' +
            files[i].name +
            '" is too large, maximum file size is 5MB.',
        );
        break;
      }

      if (
        itemType === "application/pdf" ||
        itemType === "image/jpg" ||
        itemType === "image/jpeg" ||
        itemType === "image/png"
      ) {
      } else {
        resolve('File "' + files[i].name + '" is not valid');
        break;
      }

      if (count === files.length) {
        resolve("valid");
      }
      count++;
    }
  });
};
